import { render, staticRenderFns } from "./AppForgotReactivateEmail.vue?vue&type=template&id=6d96ea03&"
import script from "./AppForgotReactivateEmail.vue?vue&type=script&lang=js&"
export * from "./AppForgotReactivateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports